import { createApi } from "@reduxjs/toolkit/query/react";
import { setCurrentProduct } from "./productSlice";
import baseQueryWithReauth from "../../common/utils/baseQueryReauth";
import config from "../../config";
import { transformType } from "./components/transformType/transformType.js";

const { envs } = config;
const { products: apiPath } = config.endpoints;

const resetLayoutOnSuccess = async (arg, { dispatch, queryFulfilled }) => {
  try {
    await queryFulfilled;
    dispatch(setCurrentProduct({}));
  } catch (error) {}
};

const productsService = createApi({
  reducerPath: "productsService",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Products"],
  endpoints: (builder) => ({
    //GET PRODUCTS PAGINATED
    getProductsPaginated: builder.query({
      // note: an optional `queryFn` may be used in place of `query`
      query: ({ activeType, page }) => ({
        url:
          apiPath.getProducts +
          "/" +
          transformType(activeType) +
          "?page=" +
          page,
      }),
      // Pick out data and prevent nested properties in a hook or selector
      transformResponse: (response, meta, arg) => response,
      // Pick out errors and prevent nested properties in a hook or selector
      transformErrorResponse: (response, meta, arg) => response.status,
      providesTags: (result) => {
        if (result && result.content) {
          return [
            ...result.content.map(({ code }) => ({
              type: "Products",
              id: code,
            })),
            { type: "Products", id: "LIST" },
          ];
        } else {
          return [{ type: "Products", id: "LIST" }];
        }
      },
      async onQueryStarted(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          queryFulfilled,
          getCacheEntry,
          updateCachedData,
        }
      ) {},
      // The 2nd parameter is the destructured `QueryCacheLifecycleApi`
      async onCacheEntryAdded(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          cacheEntryRemoved,
          cacheDataLoaded,
          getCacheEntry,
          updateCachedData,
        }
      ) {},
    }),

    //GET PRODUCTS ONLY FOR THE TRANSFER LIST IN MISSIONS AND IN PROMOPREFIX
    getProducts: builder.query({
      query: ({ activeType, page }) => ({
        url:
          apiPath.getProducts + "/" + transformType(activeType) + "?page=" + page,
      }),
      transformResponse: (response, meta, arg) => response,
      transformErrorResponse: (response, meta, arg) => response.status,
      providesTags: (result) => {
        if (result && result.content) {
          return [
            ...result.content.map(({ code }) => ({
              type: "Products",
              id: code,
            })),
            { type: "Products", id: "LIST" },
          ];
        } else {
          return [{ type: "Products", id: "LIST" }];
        }
      },
    }),

    //SEARCH PRODUCTS
    searchProducts: builder.query({
      query: ({ activeType, type, searchQuery, filters, page }) => {
        const basePath = `${apiPath.getProducts}/${transformType(type)}?`;
        let queryString = basePath;

        if (filters) {
          Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if (
              value !== "" &&
              value !== false &&
              value !== undefined &&
              value !== null
            ) {
              queryString += `&${key}=${encodeURIComponent(value)}`;
            }
          });
        }

        if (page !== null) queryString += `&page=` + page;

        console.log("Generated queryString: ", queryString);

        return { url: queryString };
      },
      transformResponse: (response, meta, arg) => {
        console.log("Transforming response: ", response);
        return response;
      },
      transformErrorResponse: (response, meta, arg) => {
        console.log("Error response: ", response.status);
        return response.status;
      },
      providesTags: (result) => {
        if (result && result.content) {
          const tags = [
            ...result.content.map(({ code }) => ({
              type: "Products",
              id: code,
            })),
            { type: "Products", id: "LIST" },
          ];
          console.log("Providing tags: ", tags);
          return tags;
        } else {
          const tags = [{ type: "Products", id: "LIST" }];
          console.log("Providing tags: ", tags);
          return tags;
        }
      },
      async onQueryStarted(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          queryFulfilled,
          getCacheEntry,
          updateCachedData,
        }
      ) {},
      // The 2nd parameter is the destructured `QueryCacheLifecycleApi`
      async onCacheEntryAdded(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          cacheEntryRemoved,
          cacheDataLoaded,
          getCacheEntry,
          updateCachedData,
        }
      ) {},
    }),

    //POST
    postProduct: builder.mutation({
      query: ({ activeType, product }) => ({
        url: apiPath.getProducts + "/" + transformType(activeType),
        method: "POST",
        body: { ...product },
      }),
      transformResponse: (response, meta, arg) => response.data,
      transformErrorResponse: (response, meta, arg) => response.status,
      invalidatesTags: ["Products"],
      onQueryStarted: resetLayoutOnSuccess,
    }),
    deleteProduct: builder.mutation({
      query: ({ id, activeType }) => ({
        url: `${apiPath.getProducts}/${transformType(activeType)}/${id}`,
        method: "DELETE",
      }),
      onQueryStarted: resetLayoutOnSuccess,
      invalidatesTags: ["Products"],
    }),

    ////provvisorio
    getEvents: builder.query({
      query: ({ activeType, page }) => ({
        url:
          "https://mservice-test.cma.lavazza.com/apiconsumerapp/eventsmanager/bo/" +
          transformType(activeType),
      }),
      transformResponse: (response, meta, arg) => response,
      transformErrorResponse: (response, meta, arg) => response.status,
      providesTags: (result) => {
        if (result && result.content) {
          return [
            ...result.content.map(({ code }) => ({
              type: "Products",
              id: code,
            })),
            { type: "Products", id: "LIST" },
          ];
        } else {
          return [{ type: "Products", id: "LIST" }];
        }
      },
    }),
  }),
});

export default productsService;

export const {
  useGetProductsQuery,
  useGetProductsPaginatedQuery,
  useSearchProductsQuery,
  usePostProductMutation,
  useDeleteProductMutation,

  useGetEventsQuery,
} = productsService;
